var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-content"
  }, [_c('h1', [_vm._v("conf")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.forceCache
    }
  }, [_vm._v("Cache fragments")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.clearCache()
      }
    }
  }, [_vm._v("Clear cache")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.userLoad()
      }
    }
  }, [_vm._v("Load workspace")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$root.userLogout()
      }
    }
  }, [_vm._v("logout")])]), _vm._v(" "), _c('h2', [_vm._v("User")]), _vm._v(" "), _c('p', [_vm._v("\n    Logged in as " + _vm._s(JSON.stringify(_vm.$root.user['@id'])) + "\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Namespaces")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$root.namespaces), function(ns) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ns.prefix))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ns.url))])])
  }))]), _vm._v(" "), _c('h2', [_vm._v("Local Storage")]), _vm._v(" "), _c('p', [_vm._v("Volgende instellingen worden bewaard in " + _vm._s(_vm.browser) + ":")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.usage), function(u) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(u.count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.key))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(u.size && u.size.toLocaleString()) + " b")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.percent.toLocaleString()) + "% of 5 MB")])])], 2)]), _vm._v(" "), _c('h2', [_vm._v("Memory")]), _vm._v(" "), _c('table', {
    staticClass: "tbl-conf",
    staticStyle: {
      "min-width": "300px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.memory), function(u) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(u.count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(u.size && u.size.toLocaleString()) + " bytes")])])
  }))])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Namespace")]), _vm._v(" "), _c('th', [_vm._v("URL")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Size")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Size")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eab6d3a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conf.vue
// module id = 42
// module chunks = 1